import styled from "@emotion/styled";
import {IS_PROD} from "modules/constants";
import React, {Fragment, useEffect, useState} from "react";
import {JSONTree} from "react-json-tree";
import {userLogin} from "modules/actions";
import {useDispatch, useSelector} from "react-redux";
import {getLoginPayload} from "modules/selectors";
import {Exists} from "components/Exists";

const Area = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	width: 25px;
	height: 25px;
	z-index: 9998;
	background: transparent;
`;

const JsonWrapper = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 9999;
	overflow: auto;

	> ul {
		margin: 0 !important;
		padding-right: 24px !important;
	}
`;

export const DebugHandler: React.FC = () => {
	const dispatch = useDispatch();
	const [count, setCount] = useState(0);
	const loginPayload = useSelector(getLoginPayload);

	useEffect(() => {
		if (count < 10) {
			return;
		}

		if (loginPayload.uid) {
			dispatch(userLogin(loginPayload));
		}
	}, [count, dispatch, loginPayload]);

	const showDebugInfo = () => {
		setCount(count + 1);
	};

	if (IS_PROD) {
		return null;
	}

	return (
		<Fragment>
			<Area onClick={showDebugInfo} />
			<Exists when={count > 10}>
				<JsonWrapper>
					<JSONTree
						// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
						data={JSON.parse(
							JSON.stringify({
								location: window.location,
								cookies: document.cookie,
								mlbOkta: window.mlbOkta,
								resource: window.performance.getEntries(),
								loginPayload: loginPayload,
							})
						)}
					/>
				</JsonWrapper>
			</Exists>
		</Fragment>
	);
};
